import { render, staticRenderFns } from "./MsdsFileUploader.vue?vue&type=template&id=0c9a31cd"
import script from "./MsdsFileUploader.vue?vue&type=script&lang=js"
export * from "./MsdsFileUploader.vue?vue&type=script&lang=js"
import style0 from "./MsdsFileUploader.vue?vue&type=style&index=0&id=0c9a31cd&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c9a31cd')) {
      api.createRecord('0c9a31cd', component.options)
    } else {
      api.reload('0c9a31cd', component.options)
    }
    module.hot.accept("./MsdsFileUploader.vue?vue&type=template&id=0c9a31cd", function () {
      api.rerender('0c9a31cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/MsdsFileUploader.vue"
export default component.exports